module.exports = __webpack_public_path__ + "static/media/transportation.1cd850d4.svg";